import { Outlet } from 'react-router-dom';
import Header from '../../pages/Public/Header';
import Footer from '../../pages/Public/Footer';

function PublicLayout() {
  return (
    <div>
      <Header />
      <main className="container mx-auto ">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default PublicLayout;